export const DEFAULT_DRAW_ID = 'defaultDrawId' as const;
